import posthog from 'posthog-js';
import ApplicationInstance from '@ember/application/instance';
import config from 'scaleflow/config/environment';

export function initialize(owner: ApplicationInstance) {
  const appConfig = owner.resolveRegistration(
    'config:environment',
  ) as typeof config;
  const { posthog: posthogConfig } = appConfig;
  if (!posthogConfig.api_key) {
    console.warn('No API key for PostHog found');
    return;
  }
  const posthogInstance = posthog.init(
    String(posthogConfig.api_key),
    {
      capture_pageview: false,
      ...(posthogConfig as Record<string, unknown>),
    },
    String(appConfig.environment),
  );

  if (posthogInstance && appConfig.environment === 'development') {
    posthogInstance.on('eventCaptured', (event) => {
      console.info('PostHog event captured:', event);
    });
  }
  owner.register('posthog:client', posthogInstance, { instantiate: false });
}

export default {
  initialize,
};
